<section class="special-area bg-white" id="about">
    <div class="special_description_area mt-150">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-xl-12 ml-xl-auto">
                    <div class="characteristics1">
                        <h2>¿Quiénes Somos?</h2>
                        <div>
                            <p>Somos una empresa Colombiana cuya misión es <b>contribuir</b> 
                                estratégicamente con el 
                                <b>desarrollo de negocios</b> 
                                en compañias que aportan VALOR al sector
                                <em>Construcción, Energías alternativas 
                                    y las TIC´s a nivel nacional.</em></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="special-area bg-white" id="offer">
    <div class="special_description_area">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-4">
                    <div class="section-heading">
                        <h2>¿Que Ofrecemos?</h2>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-4">
                    <div class="single-special wow fadeInUp tamanio" data-wow-delay="0.2s">
                        <div class="single-icon">
                            <i class="material-icons" aria-hidden="true">contact_page</i>
                        </div>
                        <h4>CONSULTORIA EMPRESARIAL</h4>
                        <p><b>Consultoría virtual</b> para analizar, diagnosticar y proponer alternativas 
                            viables, que brinden <b>soluciones eficientes</b>, que permitan alcanzar <b>objetivos comerciales
                                y estratégicos
                            </b> para pymes y emprendimientos.</p>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="single-special wow fadeInUp tamanio" data-wow-delay="0.4s">
                        <div class="single-icon">
                            <i class="material-icons" aria-hidden="true">work</i>
                        </div>
                        <h4>DESARROLLO DE NEGOCIOS B2B</h4>
                        <p>Apoyo, gestión y desarrollo de <b>procesos de negociación (ventas empresariales)</b>
                        con pymes y/o emprendedores en fase de prelanzamiento de Producto mínimo viable, para
                        generar sistemáticamente el <b>flujo de ventas</b>.</p>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="single-special wow fadeInUp tamanio" data-wow-delay="0.6s">
                        <div class="single-icon">
                            <i class="material-icons" aria-hidden="true">handyman</i>
                        </div>
                        <h4>CONSTRUCCIÓN DE EQUIPOS EN DESARROLLO NEGOCIOS</h4>
                        <p>Construcción, capacitación, entrenamiento, selección y liderazgo
                        de <b>talento humano orientado al desarrollo de negocios,</b> 
                        que contribuyan de manera eficiente en el áreas de 
                        Ventas marketing y publicidad, para aperturar, gestionar y <b>concretar negocios</b>.</p>
                    </div>
                </div>
            </div>
    </div>
</div>
</section>
<section class="special-area bg-white" id="case">
    <mdb-carousel class="carousel slide carousel-fade" [animation]="'fade'" id="case">
        <div class="hcarussel">
            <h2>CASOS DE ÉXITO</h2>
        </div>
        <mdb-carousel-item>
            <div class="view w-100">
                <img class="d-block w-100" src="assets/img/fondo2.png" alt="First slide">
                <div class="mask rgba-black-light waves-light" mdbWavesEffect></div>
            </div>
            <div class="carousel-caption">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <img class="logoCarussel" src="assets/img/logochef.png">
                            <div class="hcarussel">
                                <p>Muchas Startup's cometen el error de empezar la fase de desarrollo de software sin haber puesto en frente de un cliente real la propuesta de valor. Luego de vincularme como cofundador a TopChef, empecé a identificar los
                                    vacíos en el mercado para que a través de TopChef se brinde una experiencia diferenciadora.</p>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <img class="imageCarussel" src="assets/img/chef2.png">
                        </div>
                    </div>
                </div>
            </div>
        </mdb-carousel-item>
        <!-- <mdb-carousel-item>
            <div class="view w-100">
                <img class="d-block w-100" src="assets/img/fondo2.png" alt="First slide">
                <div class="mask rgba-black-light waves-light" mdbWavesEffect></div>
            </div>
            <div class="carousel-caption">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <img class="logoCarussel" src="assets/img/logopha2.png">
                            <div class="hcarussel">
                                <p>"Desde que creamos la plataforma Pharmakon para la administración integral de IPS desde Puxles SAS, hicimos varios intentos para crecer el número pero no tuvimos éxito. Nos inscribimos al programa de aceleración ofrecido
                                    en alianza entre IncubApp e IngHerrera para impulsar el crecimiento. En sólo 3 meses conseguimos resultados. Estamos creciendo a un ritmo de 35% trimestral".</p>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <img class="imageCarussel" src="assets/img/pha.png">
                        </div>
                    </div>
                </div>
            </div>
        </mdb-carousel-item> -->
        <mdb-carousel-item>
            <div class="view w-100">
                <img class="d-block w-100" src="assets/img/fondo2.png" alt="First slide">
                <div class="mask rgba-black-light waves-light" mdbWavesEffect></div>
            </div>
            <div class="carousel-caption">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <img class="logoCarussel" src="assets/img/logotake.png">
                            <div class="hcarussel">
                                <p>"TakeOne Sports and Technology es una startup que comenzó en 2018. La visión de TakeOne es ser un líder mundial en equipos deportivos de tecnología con hardware habilitado para plataformas web y móviles. Nuestro equipo
                                    está formado por desarrolladores y visionarios trabajadores y talentosos que impulsan la innovación en los deportes. El objetivo de TakeOne es mejorar el rendimiento de los atletas, automatizar tareas y ahorrar tiempo
                                    a los propietarios de clubes".</p>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <img class="imageCarussel" src="assets/img/take.png">
                        </div>
                    </div>
                </div>
            </div>
        </mdb-carousel-item>
        <mdb-carousel-item>
            <div class="view w-100">
                <img class="d-block w-100" src="assets/img/fondo2.png" alt="First slide">
                <div class="mask rgba-black-light waves-light" mdbWavesEffect></div>
            </div>
            <div class="carousel-caption">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <img class="logoCarussel" src="assets/img/ti.png">
                            <div class="hcarussel">
                                <p>"Gastamos más de 2 años y decenas de millones de pesos en construir una plataforma robusta para gestionar la productividad en proyectos de construcción. Luego del análisis de factibilidad del plan de crecimiento, se encontraron
                                    varias restricciones, razón por la cual se propuso un cambio de industria. Luego de 3 meses conseguimos un primer piloto. Se implementó un sistema de captación de nuevos clientes el cual está arrojando excelentes resultados".</p>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <img class="imageCarussel" src="assets/img/time.png">
                        </div>
                    </div>
                </div>
            </div>
        </mdb-carousel-item>
    </mdb-carousel>
</section>
<section class="special-area bg-white" id="contact">
    <div class="special_description_area mt-150" id="about">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="special_description_content">
                        <h2>CONTACTANOS</h2>
                    </div>
                    <br>
                    <div class="form_page">
                        <form (ngSubmit)="onSubmit(formulario)" #formulario="ngForm">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="h2modify">
                                        <h2>Diligencia el siguiente formulario y uno de nuestros representantes comerciales se pondrá en contacto contigo.</h2>
                                        <br>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <span *ngIf="formulario.submitted && formulario.controls['name'].errors" class="text-danger animated fadeIn">El nombre es obligatorio </span>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Ingresa tu nombre</mat-label>
                                        <input matInput type="text" name="name" [(ngModel)]="info.name" required>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <span *ngIf="formulario.submitted && formulario.controls['company'].errors" class="text-danger animated fadeIn">La compañia es obligatoria </span>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Ingresa el nombre de tu empresa o negocio</mat-label>
                                        <input matInput type="text" name="company" [(ngModel)]="info.company" required>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <span *ngIf="formulario.submitted && formulario.controls['description'].errors" class="text-danger animated fadeIn">La descripcion es obligatoria </span>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Breve descripcion de tus productos o servicios.</mat-label>
                                        <input matInput type="text" name="description" [(ngModel)]="info.description" required>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <span *ngIf="formulario.submitted && formulario.controls['date'].errors" class="text-danger animated fadeIn">La fecha es obligatoria </span>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Selecciona un dia y una hora al que te podamos llamar</mat-label>
                                        <input matInput type="datetime-local" name="date" [(ngModel)]="info.date" required>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <span *ngIf="formulario.submitted && formulario.controls['date'].errors" class="text-danger animated fadeIn">La fecha es obligatoria </span>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Teléfono</mat-label>
                                        <input matInput type="text" name="phone" [(ngModel)]="info.phone" required>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <span *ngIf="formulario.submitted && formulario.controls['date'].errors" class="text-danger animated fadeIn">La fecha es obligatoria </span>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Correo electrónico</mat-label>
                                        <input matInput type="text" name="email" [(ngModel)]="info.email" required>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row " style="margin-top: 20px; ">
                                <div class="col-md-6 ">
                                    <div class="sign-in-button" style="font-size: 14px; ">
                                        <button mat-button type="submit" class="secondary-button">Enviar Informacion</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="col-lg-6 col-xl-5 ml-xl-auto">
                    <div class="special_description_content">
                        <img class="centrar" src="assets/img/logoPrincipal.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>